module.exports = __webpack_public_path__ + "static/crop_bh-260f6a513d0e21be44208b2a1de980e1.png";